import { RefObject, useCallback } from 'react';
import { useEvent, useUnit } from 'effector-react';
import { ResizeLine } from '@nx-frontend/shared/ui/resize-line';
import { $isNoteFullScreen } from '@nx-frontend/shared/store/note-fullscreen';
import { $sidebar, setIsSidebarResizingEvent, setSidebarWidthEvent } from '@nx-frontend/shared/store/sidebar';

export function SidebarResizeLine({
  sidebarRef,
  offset = 0,
}: {
  sidebarRef: RefObject<HTMLDivElement>;
  offset: number;
}) {
  const [sidebar, isNoteFullScreen] = useUnit([$sidebar, $isNoteFullScreen]);
  const [setSidebarWidth, setIsSidebarResizing] = useEvent([setSidebarWidthEvent, setIsSidebarResizingEvent]);

  const handeSidebarResize = useCallback(
    (width: number) => {
      window.dispatchEvent(new CustomEvent('sidebar:resize', { detail: { width } }));
      setSidebarWidth(width);
    },
    [setSidebarWidth]
  );

  const handleMouseDown = useCallback(() => {
    setIsSidebarResizing(true);
  }, [setIsSidebarResizing]);

  const handleMouseUp = useCallback(() => {
    setIsSidebarResizing(false);
  }, [setIsSidebarResizing]);

  if (isNoteFullScreen) {
    return;
  }

  return (
    <ResizeLine
      target={sidebarRef}
      min={230}
      max={360}
      additionStyles={{ left: `${sidebar.width + offset}px`, zIndex: '10' }}
      handleResize={handeSidebarResize}
      additionProps={{ 'data-cy': 'sidebar-resizer' }}
      side="right"
      showIcon={false}
      mouseDown={handleMouseDown}
      mouseUp={handleMouseUp}
    />
  );
}
